import { Spinner } from "@win-reality/react-ui";

function PageSpinner() {
  return (
    <div className="flex h-full min-h-[50vh] w-full items-center justify-center">
      <Spinner size="screen" />
    </div>
  );
}

export { PageSpinner };
